module.exports = __webpack_public_path__ + "static/media/ic_allow.8277acb9.svg";